export default function getResource(label, vars = []) {
    const resources = {
        compareProducts: 'Comparer les articles',
        emptySlot: 'Vide',
        unableToCompareProductsTitle: 'Impossible de comparer les articles',
        unableToCompareProductsMessage: 'Un problème est survenu. Veuillez réessayer dans un instant.',
        gotIt: 'Compris',
        colors: 'Couleurs',
        color: 'Couleur',
        sizes: 'Formats',
        size: 'format',
        standardSize: 'Format standard : ',
        ratingsAndReviews: 'Évaluations et commentaires',
        prosMentioned: 'Pour mentionnés',
        consMentioned: 'Inconvénients mentionnés',
        overview: 'Aperçu',
        ingredients: 'Ingrédients',
        pickupAndDelivery: 'Ramassage et livraison',
        showAll: 'Afficher tout',
        showLess: 'Afficher moins',
        bopis: 'Achat en ligne et ramassage au magasin ',
        gis: 'Faites livrer : ',
        sdd: 'Livraison le jour même : ',
        setLocation: 'Définir l’emplacement',
        inStock: 'En stock',
        outOfStock: 'Rupture de stock',
        notAvailable: 'Non disponible',
        onlineOnly: 'En ligne seulement',
        storeOnly: 'En magasin seulement',
        goodFor: 'Idéal pour',
        targetedConcerns: 'Cible les préoccupations suivantes',
        benefits: 'Bienfaits',
        removeProduct: 'Retirer l’article',
        openProductDetails: 'Afficher les détails de l’article :',
        noValues: 'Aucune valeur à comparer',
        productInformation: `Renseignements sur l’article : ${vars[0]}`,
        bopisSection: 'Achetez en ligne, ramassez en magasin :',
        gisSection: 'Faites livrer :',
        sddSection: 'Livraison le jour même :',
        gisEmptyStatePrefix: 'Cliquez pour voir les options de livraison pour ',
        gisEmptyStateBold: 'votre emplacement',
        bopisEmptyStatePrefix: 'Cliquez pour voir la disponibilité pour le ramassage au magasin ',
        bopisEmptyStateBold: 'magasins près de chez vous'
    };

    return resources[label];
}
